/** DamageBlockSlot — two checkboxes + conditional notes input + NCR hint. */
import { Field } from "../_shared";
import { Input } from "@/components/ui/input";
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function DamageBlockSlot({ values, set }) {
  const lbl = useSlotLabel("qa.damage");
  return (
    <div className="rounded-md border border-rose-200 bg-rose-50/40 p-3 space-y-2" data-testid="damage-block">
      <div className="text-xs uppercase tracking-wider text-rose-700 font-medium">
        {lbl("section_title", "Damage (FLD entry)")}
      </div>
      <div className="flex flex-wrap gap-6 text-sm">
        <label className="inline-flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={!!values.damage_pallets}
                 onChange={(e) => set("damage_pallets", e.target.checked)}
                 data-testid="damage-pallets" />
          <span>{lbl("pallets", "Damage — pallets")}</span>
        </label>
        <label className="inline-flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={!!values.damage_products}
                 onChange={(e) => set("damage_products", e.target.checked)}
                 data-testid="damage-products" />
          <span>{lbl("products", "Damage — products")}</span>
        </label>
      </div>
      {(values.damage_pallets || values.damage_products) && (
        <>
          <Field label={lbl("notes", "Damage notes")}>
            <Input data-testid="damage-notes-input"
                   value={values.damage_notes}
                   onChange={(e) => set("damage_notes", e.target.value)} />
          </Field>
          <p className="text-[11px] text-rose-700">
            Ticking damage opens an NCR (issue type:
            {values.damage_pallets ? <em> Pallets</em> : null}
            {values.damage_pallets && values.damage_products ? " + " : null}
            {values.damage_products ? <em> Product</em> : null}
            ) when this booking is saved.
          </p>
        </>
      )}
    </div>
  );
}
